class Clients {
  constructor() {
    this.clientsSections = document.getElementsByClassName("clients");
    if (this.clientsSections[0]) {
      this.init();
    }
  }

  /* eslint-disable class-methods-use-this, no-unused-vars */
  init() {
    Promise.all([
      import(/* webpackChunkName: "library-swiper" */ "swiper"),
      import(
        /* webpackChunkName: "library-swiper-modules" */ "swiper/modules" // eslint-disable-line
      ),
    ])
      .then(([{ default: Swiper }, { Autoplay }]) => {
        Array.from(this.clientsSections).forEach((section) =>
          this.initSlider(section, Swiper, Autoplay)
        );
      })
      .catch((err) => console.log(err)); // eslint-disable-line
  }

  initSlider(section, Swiper, Autoplay) {
    const slidesNum = section.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    ).length;
    const swiperContainer = section.querySelector(".swiper-container");
    const galleryContainerDivs = section.querySelectorAll(
      ".gallery__container > div"
    );
    const speed = section.dataset.speed; // eslint-disable-line
    const adjustedSpeed = 3000 / speed;

    if (galleryContainerDivs !== null) {
      galleryContainerDivs.forEach((galleryContainerDiv) => {
        const galleryContainerDivsSrc =
          galleryContainerDiv.firstElementChild.dataset.src;

        const galleryContainerDivsSrcExtension = galleryContainerDivsSrc.slice(
          (Math.max(0, galleryContainerDivsSrc.lastIndexOf(".")) || Infinity) +
            1
        );
        if (galleryContainerDivsSrcExtension === "png") {
          galleryContainerDiv.classList.add("gallery__container__item-contain");
        }
      });
    }

    this.swiperInstance = new Swiper(swiperContainer, {
      modules: [Autoplay],

      // Optional parameters
      allowTouchMove: false,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
      loopedSlides: slidesNum,
      speed: adjustedSpeed,
      grabCursor: false,
      mousewheelControl: false,
      keyboardControl: false,
      on: {
        /* eslint-disable */
        init: function () {
          const swiper = swiperContainer.swiper;
          let initSwiperTransform = section.querySelector(
            ".clients__list.swiper-wrapper.col-group"
          );

          const disableSwiper = () => {
            swiper.disable();
            swiper.loopDestroy();
            swiper.autoplay.stop();
            initSwiperTransform.classList.add("init-swiper-transform");
          };

          const enableSwiper = () => {
            swiper.enable();
            swiper.loopCreate();
            swiper.autoplay.start();
            initSwiperTransform.classList.remove("init-swiper-transform");
          };

          const getWidth = () => {
            var w = window.innerWidth;

            if (w >= 1100 && slidesNum < 7) {
              disableSwiper();
            } else {
              enableSwiper();
            }
          };

          window.addEventListener("resize", getWidth);
          getWidth();
        },
        /* eslint-enable */
      },
    });
  }
  /* eslint-enable class-methods-use-this, no-unused-vars */
}

export default Clients;
